module.exports = __webpack_public_path__ + "img/facebook.4b3974a8.png";